import { WallpaperConfig } from '../config/wallpaper-config';

export const AdUnitsService = {
  calculateInterval(position) {
    for (const interval of WallpaperConfig.rotationIntervals) {
      const [maxPosition, rotationInterval] = interval;
      if (position >= maxPosition) return rotationInterval;
    }

    // Default to 45s seconds interval just to be safe.
    return WallpaperConfig.defaultRotationInterval;
  },

  calculateSlots(position) {
    const slots = [];

    for (const zoneId of Object.keys(WallpaperConfig.rotationSlots)) {
      const [min, max] = WallpaperConfig.rotationSlots[zoneId];
      // If the position is within the slot interval, add it to the list
      if (position >= min && position <= max) {
        slots.push(parseInt(zoneId, 10));
      }
    }

    return slots;
  },
};
